import { getLoadingBridge } from "@/lib/loadingBridge";

export type WithLoaderOptions = {
  message?: string;
  mode?: "overlay" | "progress";
};

/**
 * Runs an async function with global overlay loading. Always stops the loader in `finally`
 * (one stop per call — pair with matching start depth from bridge).
 */
export async function withLoader<T>(fn: () => Promise<T>, options?: WithLoaderOptions): Promise<T> {
  const bridge = getLoadingBridge();
  const message = options?.message ?? "Loading...";
  if (!options?.mode || options.mode === "overlay") {
    bridge?.startLoading(message);
  }
  try {
    return await fn();
  } finally {
    bridge?.stopLoading();
  }
}

/**
 * Wraps a fetch Response promise (or any promise) with overlay loading.
 */
export async function fetchWithLoader(
  input: RequestInfo | URL,
  init?: RequestInit,
  message = "Loading...",
): Promise<Response> {
  return withLoader(() => fetch(input, init), { message });
}
